export default __webpack_public_path__ + "static/media/Password-illustration.1d138f72.svg";